import React, { useState, useEffect } from "react";
import { SketchPicker } from "react-color";
import { createPortal } from "react-dom";
import { IoColorPaletteOutline, IoClose } from "react-icons/io5";
// import { TRYON_SERVER_URL } from "../config";
// import axios from "axios";
import { BG_IMAGES, THUMBNAIL_IMAGES, COLOR_OPTIONS } from "./BGOptions"

const ChangeBackground = ({ addBackground, setCurrentImage, imageWithTransparentBackground, setAddBackgroundMode, handleTool }) => {
  const [activeTab, setActiveTab] = useState("photo");
  const [selectedColor, setSelectedColor] = useState("#ffffff");
  const [showColorPicker, setShowColorPicker] = useState(false);
//   const [backgroundImages, setBackgroundImages] = useState([]);
//   const [backgroundThumbnails, setBackgroundThumbnails] = useState([]);
//   const [backgroundImagesFetched, setBackgroundImagesFetched] = useState(false);
//   const [fetchingBackgroundImages, setFetchingBackgroundImages] = useState(false);

//   const fetchBackgroundImages = async () => {
//     setFetchingBackgroundImages(true);
//     const response = await fetch(`${TRYON_SERVER_URL}/api/v1/studio/backgrounds/`);
//     if (response.ok) {
//       const data = await response.json();
//       console.log("data", data);
//       setBackgroundImages(data['images']);
//       setBackgroundThumbnails(data['thumbnails']);
//       setBackgroundImagesFetched(true);
//       setFetchingBackgroundImages(false);
//     }
//     else {
//       console.error("Failed to fetch background images");
//       setBackgroundImagesFetched(false);
//       setFetchingBackgroundImages(false);
//     }
//   }
  
//   useEffect(() => {
//     if(!backgroundImagesFetched && !fetchingBackgroundImages) {
//       fetchBackgroundImages();
//     }
//   }, [backgroundImagesFetched, fetchingBackgroundImages]);

  const handleUpload = async (e) => {
    console.log("handleUpload", e.target.files[0]);
    const file = e.target.files[0];
    if (file) {
      await handleTool("remove_background", URL.createObjectURL(file), null, false);
    }
  };

  const handleColorPick = async (color) => {
    console.log("color", color);
    setSelectedColor(color.hex);
    await handleTool("remove_background", null, color.hex, false);
  };

//   const downloadLargeBackgroundImage = (url) => {
//     console.log("downloadLargeBackgroundImage", url);
//     //axios with cross origin image downloadLargeBackgroundImage
//     axios.defaults.withCredentials = true;
//     axios.get(url, {
//       responseType: 'blob',
//       headers: {
//         'Accept': 'image/*',
//         'Access-Control-Allow-Origin': '*'
//       }
//     }).then(response => {
//       const imageUrl = URL.createObjectURL(response.data);
//       console.log("imageUrl", imageUrl);
//       handleTool("remove_background", imageUrl, null, false).then(() => {
//       });
//     }).catch(error => {
//       console.error('Error downloading image:', error);
//     });
//   }

  return (

      <div className="relative mx-auto flex flex-col items-start justify-start" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-start h-full">
          {/* Control panel */}
          <div className="relative w-[300px] h-[500px] shadow-lg border border-gray-200/80 bg-gray-50 z-10 rounded-lg flex flex-col">

            <div className="flex justify-between items-center p-3 border-b bg-white rounded-t-lg">
              <h3 className="text-base font-medium text-gray-700">Change Background</h3>
              <button
                onClick={() => {
                  setAddBackgroundMode(false);
                }}
                className="text-gray-500 hover:text-red-600 transition"
                title="Close"
              >
                <IoClose className="h-5 w-5" />
              </button>
            </div>

            {/* Header */}
            <div className="flex justify-between items-center p-2 bg-white/50">
              <div className="flex rounded-lg w-full">
                <button
                  onClick={(e) => {
                    setActiveTab("photo");
                    setShowColorPicker(false);
                  }}
                  className={`flex-1 py-1.5 text-sm rounded-l-lg transition-all duration-200 ${
                    activeTab === "photo"
                      ? "bg-secondary text-white font-semibold shadow-sm"
                      : "bg-white text-secondary hover:bg-gray-50 border border-gray-200"
                  }`}
                >
                  Photo
                </button>
                <button
                  onClick={(e) => {
                    setActiveTab("color");
                    setShowColorPicker(false);
                  }}
                  className={`flex-1 py-1.5 text-sm rounded-r-lg transition-all duration-200 ${
                    activeTab === "color"
                      ? "bg-secondary text-white font-semibold shadow-sm"
                      : "bg-white text-secondary hover:bg-gray-50 border border-gray-200"
                  }`}
                >
                  Color
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-2 mb-2">
              {/* Photo  */}
              {activeTab === "photo" && (
                <div className="grid grid-cols-2 gap-3 px-1 h-full">
                  <label className="flex items-center justify-center w-full aspect-square border border-dashed border-secondary hover:border-primary rounded-lg cursor-pointer text-secondary bg-white hover:bg-gray-50 hover:text-primary transition-all duration-300 cursor-pointer">
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleUpload}
                    />
                    +
                  </label>
                  {THUMBNAIL_IMAGES.map((thumbnail, i) => (
                    <div key={i} className="relative w-full aspect-square">
                      <img
                        src={thumbnail}
                        alt={`bg-${i}`}
                        loading="lazy"
                        className="w-full h-full object-cover rounded-lg transition-all duration-200 cursor-pointer hover:ring-2 hover:ring-blue-400 hover:scale-105"
                        onClick={(e) => {
                          handleTool("remove_background", BG_IMAGES[i], null, false).then(() => {
                          });
                          e.stopPropagation();
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* Color  */}
              {activeTab === "color" && (
                <div className="flex flex-wrap gap-2 grid grid-cols-5">
                  <div className="relative">
                    <button
                      onClick={() => setShowColorPicker(!showColorPicker)}
                      className="w-full aspect-square rounded-full bg-gray-100 border hover:bg-gray-50 hover:scale-105 transition-all duration-200 flex items-center justify-center"
                    >
                      <IoColorPaletteOutline className="w-6 h-6 text-secondary" />
                    </button>
                  </div>
                  {COLOR_OPTIONS.map((clr, i) => (
                    <div
                      key={i}
                      className="w-full aspect-square rounded-full cursor-pointer border-2 hover:scale-105 transition-all duration-200"
                      style={{
                        backgroundColor: clr,
                        borderColor:
                          clr === selectedColor
                            ? "rgba(59, 130, 246, 0.8)"
                            : "rgba(0, 0, 0, 0.1)",
                        borderWidth: clr === selectedColor ? "3px" : "2px",
                        boxShadow: clr === selectedColor ? "0 0 0 2px rgba(59, 130, 246, 0.2)" : "none"
                      }}
                      onClick={async (e) => {
                        setSelectedColor(clr);
                        await handleTool("remove_background", null, clr, false);
                        e.stopPropagation();
                      }}
                    ></div>
                  ))}
                  
                </div>
              )}
            </div>

            <div className="px-4 py-2 bg-white rounded-b-lg">
              <button 
                className="w-full text-sm bg-transparent border border-secondary text-secondary hover:bg-secondary/10 px-3 py-1 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 font-medium"
                onClick={() => {
                  setCurrentImage(imageWithTransparentBackground);
                  setAddBackgroundMode(false);
                }}
              >
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Reset Background
              </button>
            </div>
          </div>
        </div>

        {showColorPicker &&
          createPortal(
            <div 
              className="fixed inset-0 z-[9998]"
              onClick={() => setShowColorPicker(false)}
            >
              <div
                className="absolute"
                style={{
                  top: "40%",
                  right: "5%",
                  transform: "translate(0%, 0%)",
                  zIndex: 9999,
                }}
                onClick={e => e.stopPropagation()}
              >
                <div className="relative bg-white rounded-lg shadow-xl border border-gray-200/80 p-2">
                  <SketchPicker
                    color={selectedColor}
                    onChangeComplete={handleColorPick}
                  />
                </div>
              </div>
            </div>,
            document.body
          )}
      </div>
  );
};

export default ChangeBackground;
